import { MenuItem, Stack, Typography } from "@mui/material";
import { Calendar as BigCalendar, Views, dateFnsLocalizer } from 'react-big-calendar';
import format from 'date-fns/format';
import parse from 'date-fns/parse';
import startOfWeek from 'date-fns/startOfWeek';
import getDay from 'date-fns/getDay';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css';
import { useEffect, useState } from "react";
import index from "../../../api/auth/reservations";
import indexItemCategories from "../../../api/auth/itemCategories/getItemCategories";
import { red } from "@mui/material/colors";
import ReservationSlot from "../calendar/ReservationSlot";
import PageLoading from "../../layout/PageLoading";
import useItemStore from "../../../stores/useItemStore";
import { addDays } from "date-fns";
import WushTextField from "../../form/WushTextField";

const locales = {
	"en-US": require("date-fns")
};

const localizer = dateFnsLocalizer({
	format,
	parse,
	startOfWeek,
	getDay,
	locales
});

export default function Calendar({ views, defaultView, height }) {
  const [reservations, setReservations] = useState();
  const [reservationsLoading, setReservationsLoading] = useState(false);
  const [selectedDay, setSelectedDay] = useState(format(new Date(), 'yyyy-MM-dd'));
  const [selectedItemCategoryId, setSelectedItemCategoryId] = useState();

  const { itemCategories, setItemCategories } = useItemStore();

  useEffect(() => {
    if(reservations) return;
    setReservationsLoading(true);
    index({
      status: ['confirmed', 'paid']
    }, (response) => {
      setReservations(response);
      setReservationsLoading(false);
    });
  }, []);

  useEffect(() => {
    if(itemCategories.length === 0) {
      indexItemCategories((response) => {
        setItemCategories(response);
      });
    }
  }, []);

  const eventPropGetter = (reservation) => {
    console.log(reservation?.reservation_items[0]?.item?.item_category?.tag_color);
    var backgroundColor =  reservation?.reservation_items[0]?.item?.item_category?.tag_color;
    var style = {
        backgroundColor: backgroundColor,
        borderRadius: '0px',
        opacity: 0.8,
        color: 'black',
        border: '0px',
        display: 'block',
    };
    return {
        style: style
    };
  };

  const getReservations = () => {
    if(selectedItemCategoryId) {
      return reservations.filter((reservation) => reservation.item_category_ids.includes(selectedItemCategoryId));
    } else {
      return reservations;
    }
  };

  const getResources = () => {
    if(selectedItemCategoryId) {
      return itemCategories.filter((itemCategory) => itemCategory.id === selectedItemCategoryId);
    } else {
      return itemCategories;
    }
  };

  if(reservationsLoading || itemCategories.length === 0) return <PageLoading />;

  return (
    <Stack
      sx={{
        '.rbc-row-segment': {
          '.rbc-event-allday': {
            '&:not(.rbc-event-continues-prior)': {
              borderLeft: `5px solid #00b4d2 !important`,
            },
            '&:not(.rbc-event-continues-after)': {
              borderRight: `5px solid ${red.A400} !important`
            }
          }
        }
      }}
    >
      <Stack mb={2}>
        <Stack mb={1}>
          <Typography variant="h4">Calendar</Typography>
        </Stack>
        <Stack direction="row" width={{ xs: "auto", sm: "25%" }} mb={1}>
          <WushTextField formRegistration={{ onChange: (e) => setSelectedDay(format(addDays(e.target.value, 1), 'yyyy-MM-dd')) }} value={selectedDay} type="date" label="Select a day" />
        </Stack>
        <Stack direction="row" width={{ xs: "auto", sm: "25%" }}>
          <WushTextField
            formRegistration={{ onChange: (e) => setSelectedItemCategoryId(e.target.value) }}
            value={selectedItemCategoryId}
            label="Select item category" select
          >
            {itemCategories.map((itemCategory) => (
              <MenuItem key={itemCategory.id} value={itemCategory.id}>
                {itemCategory.name}
              </MenuItem>
            ))}
          </WushTextField>
        </Stack>
      </Stack>
      <BigCalendar
        onNavigate={(date) => setSelectedDay(format(date, 'yyyy-MM-dd'))}
        views={views || [Views.MONTH, Views.DAY]}
        defaultView={defaultView || Views.DAY}
        dayLayoutAlgorithm='no-overlap'
        date={addDays(new Date(selectedDay), 1)}
        localizer={localizer}
        events={getReservations()}
        resources={getResources()}
        resourceIdAccessor="item_category_id"
        resourceTitleAccessor="name"
        startAccessor={(reservation) => new Date(reservation.start_at)}
        endAccessor={(reservation) => new Date(reservation.end_at)}
        style={{ height: height || '65vh' }}
        titleAccessor={(reservation) => <ReservationSlot key={reservation.id} reservation={reservation} />}
        eventPropGetter={(eventPropGetter)}
      />
    </Stack>
  );
}